import {isSSR} from "./isSSR";

export const moveTo = (positionX, positionY) => {
  if (isSSR()) {
    return;
  }
  
  window.scrollTo(positionX, positionY);
};
